import { render, staticRenderFns } from "./QuestionsView.vue?vue&type=template&id=2eddbacd&scoped=true"
import script from "./QuestionsView.vue?vue&type=script&lang=js"
export * from "./QuestionsView.vue?vue&type=script&lang=js"
import style0 from "./QuestionsView.vue?vue&type=style&index=0&id=2eddbacd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eddbacd",
  null
  
)

export default component.exports